export default __webpack_public_path__ + "static/media/map-pin.dae61f02.svg";